export default __webpack_public_path__ + "static/media/bulk_icon.05c0976a.svg";